<template>
  <div>
    <b-card>
      <h4 class="mb-0">Olá, {{ $store.state.user.name }}</h4>
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";

export default {
  components: {
    BCard,
  },
};
</script>
